"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _Option = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/Option"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ComboBox = /*#__PURE__*/function (_React$Component) {
  _inherits(ComboBox, _React$Component);

  var _super = _createSuper(ComboBox);

  function ComboBox(props) {
    var _this;

    _classCallCheck(this, ComboBox);

    _this = _super.call(this, props);
    _this.state = {
      query: ''
    };
    _this._handleItemChange = _this._handleItemChange.bind(_assertThisInitialized(_this));
    _this._handleClearClicked = _this._handleClearClicked.bind(_assertThisInitialized(_this));
    _this._handleSelectAllChange = _this._handleSelectAllChange.bind(_assertThisInitialized(_this));
    _this._handleQueryChange = _this._handleQueryChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ComboBox, [{
    key: "_handleQueryChange",
    value: function _handleQueryChange(e) {
      this.setState({
        query: e.target.value
      });
    }
  }, {
    key: "_handleItemChange",
    value: function _handleItemChange(itemValue) {
      if (!this.props.editable) {
        return;
      } // Clone the array, we're going to mutate it.


      var arrayClone = (this.props.selected || []).slice();
      var optIndex = arrayClone.indexOf(itemValue);

      if (arrayClone.indexOf(itemValue) >= 0) {
        arrayClone.splice(optIndex, 1);
      } else {
        arrayClone.push(itemValue);
      }

      this.props.onChange(arrayClone);
    }
  }, {
    key: "_handleClearClicked",
    value: function _handleClearClicked(e) {
      e.preventDefault();

      if (!this.props.editable) {
        return;
      }

      this.props.onChange([]);
    }
  }, {
    key: "_handleSelectAllChange",
    value: function _handleSelectAllChange(e) {
      if (!this.props.editable) {
        return;
      }

      var target = e.target;

      if (target.checked) {
        this.props.onChange(this.props.options.filter(function (item) {
          return !item.disabled;
        }) // Don't select disabled items
        .map(function (item) {
          return item.value;
        }));
      } else {
        this.props.onChange([]);
      }
    }
  }, {
    key: "_renderItemList",
    value: function _renderItemList() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          options = _this$props.options,
          selected = _this$props.selected,
          noMatchingItemsMessage = _this$props.noMatchingItemsMessage,
          editable = _this$props.editable,
          filterQuery = _this$props.filterQuery;
      var itemsToShow = options;

      if (editable) {
        itemsToShow = options.filter(function (item) {
          return item.label.toLowerCase().includes(filterQuery.toLowerCase());
        });
      }

      if (!itemsToShow.length) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "combo-box__no-results"
        }, noMatchingItemsMessage);
      }

      return /*#__PURE__*/_react.default.createElement("ul", null, itemsToShow.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: item.id
        }, /*#__PURE__*/_react.default.createElement(_Option.default, {
          id: "".concat(id, "-").concat(item.value),
          name: "".concat(id, "-").concat(item.value),
          label: item.label,
          onChange: function onChange() {
            _this2._handleItemChange(item.value);
          },
          checked: (selected || []).indexOf(item.value) >= 0,
          disabled: item.disabled
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          options = _this$props2.options,
          selected = _this$props2.selected,
          numItemsMessage = _this$props2.numItemsMessage,
          numSelectedMessage = _this$props2.numSelectedMessage,
          selectAllLabel = _this$props2.selectAllLabel,
          editable = _this$props2.editable,
          onChange = _this$props2.onChange,
          noMatchingItemsMessage = _this$props2.noMatchingItemsMessage,
          filterQuery = _this$props2.filterQuery,
          restProps = _objectWithoutProperties(_this$props2, ["id", "options", "selected", "numItemsMessage", "numSelectedMessage", "selectAllLabel", "editable", "onChange", "noMatchingItemsMessage", "filterQuery"]);

      var classes = (0, _classnames.default)('combo-box', {
        'combo-box--readonly': !editable
      });
      var numItems = options.length;
      var numAvailableItems = options.filter(function (item) {
        return !item.disabled;
      }).length;
      var numSelected = (selected || []).length;
      var isDisabled = numAvailableItems === 0;
      var showClearButton = editable && !!numSelected;

      var clearButton = /*#__PURE__*/_react.default.createElement("button", {
        onClick: this._handleClearClicked,
        type: "button",
        className: "faux-link combo-box__clear"
      }, "clear ", /*#__PURE__*/_react.default.createElement("span", {
        className: "vh"
      }, "selection"));

      return /*#__PURE__*/_react.default.createElement(_Control.default, _extends({
        name: id
      }, restProps), /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "combo-box__utils"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "combo-box-utils__select-all"
      }, /*#__PURE__*/_react.default.createElement(_Option.default, {
        id: "".concat(id, "-select-all"),
        name: "".concat(id, "-select-all"),
        label: selectAllLabel,
        onChange: this._handleSelectAllChange,
        checked: numAvailableItems && numAvailableItems === numSelected,
        disabled: isDisabled
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "combo-box-utils__status"
      }, numItemsMessage(numItems), " (", numSelectedMessage(numSelected), showClearButton && ' ', showClearButton && clearButton, ")")), /*#__PURE__*/_react.default.createElement("div", {
        className: "combo-box__items"
      }, this._renderItemList())));
    }
  }]);

  return ComboBox;
}(_react.default.Component);

ComboBox.defaultProps = {
  options: [],
  selected: [],
  onChange: function onChange() {},
  editable: true,
  filterQuery: '',
  numItemsMessage: function numItemsMessage(numItems) {
    return "".concat(numItems, " items");
  },
  numSelectedMessage: function numSelectedMessage(numSelected) {
    return "".concat(numSelected, " selected");
  },
  selectAllLabel: 'Select all',
  noMatchingItemsMessage: 'No results found'
};
ComboBox.propTypes = {
  id: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node,
    value: _propTypes.default.string,
    disabled: _propTypes.default.bool
  })),
  selected: _propTypes.default.arrayOf(_propTypes.default.string),
  onChange: _propTypes.default.func,
  editable: _propTypes.default.bool,
  filterQuery: _propTypes.default.string,
  numItemsMessage: _propTypes.default.func,
  numSelectedMessage: _propTypes.default.func,
  selectAllLabel: _propTypes.default.string,
  noMatchingItemsMessage: _propTypes.default.string
};
var _default = ComboBox;
exports.default = _default;
//# sourceMappingURL=ComboBox.js.map